<template>
    <v-layout row justify-center>
        <v-dialog v-model="openDialog" max-width="600px">
            <v-card>
                <v-card-text>
                    <v-container grid-list-md class="feedback-container">
                        <h2 class="feedback-title">Оставьте заявку</h2>
                        <v-layout wrap>
                            <v-flex xs12>
                                <div ref="formContainer"></div>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-layout>
</template>
<script>
    export default {
        name: "BitrixForm",
        props: ['dialog'],

        data: () => ({
            openDialog: false,
        }),
        watch: {
            dialog(value) {
                if (value) {
                    this.openDialog = true
                    this.$emit('closeBitrixDialog')
                }
            }
        },
        methods: {

        },
        mounted() {
            const script = document.createElement('script')
            script.src = 'https://cdn-ru.bitrix24.ru/b33289040/crm/form/loader_13.js?' + (Date.now()/180000|0)
            script.dataset.b24Form = 'inline/13/3ez1sn'
            script.dataset.skipMoving = 'true'
            this.$refs.formContainer.appendChild(script)
        },
    }
</script>
<style scoped lang="scss">
    .button {
        line-height: 1.45 !important;
        font-weight: 700 !important;
        font-size: 16px !important;
        text-transform: none !important;
        box-shadow: none !important;

        width: 100%;
        height: 54px;
        text-align: center;
        display: table-cell;
        vertical-align: middle;
        padding: 0 !important;
        margin: 10px 20px 0 0;

        border-width: 1px;
        border-radius: 30px;
        border-style: solid;
    }

    .button >>> .v-btn__content {
        white-space: normal;
        line-height: 1.1;
    }

    .next-button {
        color: #ffffff !important;
        background-color: #00ba57 !important;
        border-color: transparent;
    }
    .feedback-title{
        font-family: 'SFUIDisplay';
        font-weight: 700;
        font-size: 36px;
        line-height: 1.23;
        margin-bottom: 11px;
        text-align: center;
    }
    .feedback-info{
        width: 100%;
        padding: 20px;
        text-align: center;
        font-family: 'SFUIDisplay',Arial,sans-serif;
        color: #fff;
        font-size: 20px;
        line-height: 1.55;
        height: 70px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 10px 0 20px;
    }
    .feedback-no-data{
        background-color: #F95D51;
    }
    .feedback-success{
        background-color: #62C584;
    }
</style>
<style>
    .feedback-container .theme--light.v-text-field > .v-input__control > .v-input__slot:before{
        height: 1px;
        background-color: #ccc;
    }
    .feedback-container .v-input input{
        background-color: #ffffff;
    }
    .feedback-container textarea{
        padding: 25px 15px 0px;
    }
    .feedback-container p{
        margin-top: 20px;
        text-align: center;
        font-size: 15px;
        line-height: 1.55;
    }
    .feedback-container a{
        text-decoration: underline;
        color: rgb(0, 166, 42)
    }
    .feedback-container a:hover{
        color: rgb(0, 166, 42)
    }
    .b24-form-btn-block {
        button {
            color: #ffffff !important;
            background-color: #00ba57 !important;

            &:hover {
                background-color: #00ba57 !important;
            }
        }
    }
    .b24-form-wrapper.b24-form-border-bottom {
        border-bottom: unset !important;
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/elements/BitrixForm.vue